import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { galleryImages } from '../mock';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function Gallery() {
  const [idx, setIdx] = useState(null);

  const prev = () => setIdx((i) => (i - 1 + galleryImages.length) % galleryImages.length);
  const next = () => setIdx((i) => (i + 1) % galleryImages.length);

  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1548417153-e49c8d900980?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Moments</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">Photo Gallery</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <Reveal>
            <SectionHeader center eyebrow="Highlights" title="Through the Lens" subtitle="A curated glimpse into life at Etawah Lion Safari." />
          </Reveal>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((img, i) => (
              <Reveal key={i} delay={(i % 4) * 90}>
                <div className="gallery-item aspect-square" onClick={() => setIdx(i)}>
                  <img src={img} alt={`gallery-${i}`} />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {idx !== null && (
        <div className="fixed inset-0 bg-[#1a1108]/95 z-[100] flex items-center justify-center p-4" onClick={() => setIdx(null)}>
          <button className="absolute top-6 right-6 text-[#f7e6c2] hover:text-[#f0b040]" onClick={() => setIdx(null)}><X size={30} /></button>
          <button className="absolute left-6 text-[#f7e6c2] hover:text-[#f0b040]" onClick={(e) => { e.stopPropagation(); prev(); }}><ChevronLeft size={40} /></button>
          <img src={galleryImages[idx]} alt="large" className="max-h-[85vh] max-w-[85vw] rounded-lg shadow-2xl" onClick={(e) => e.stopPropagation()} />
          <button className="absolute right-6 text-[#f7e6c2] hover:text-[#f0b040]" onClick={(e) => { e.stopPropagation(); next(); }}><ChevronRight size={40} /></button>
        </div>
      )}
    </div>
  );
}
